import { inject } from '@angular/core';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
export class UniverseQuartileChartService {
    constructor() {
        this.ajaxService = inject(AjaxService);
        this.urlsService = inject(UrlsService);
    }
    /**
     * Fetch the universe distribution and the targets' series for one metric.
     *
     * Params go over as a form-encoded POST rather than a query string because a universe request
     * carries a security list name and up to five target ids, and the endpoint reads `request.POST`.
     *
     * Errors are left unformatted so callers can tell a 400/413 -- which carry a `message` worth
     * showing the user -- apart from a generic failure.
     */
    getQuartileChartData(params) {
        const url = this.urlsService.CHARTS.UNIVERSE_QUARTILE_CHART_DATA;
        return this.ajaxService.postFormEncodedDataObserveBody(url, { ...params });
    }
}
UniverseQuartileChartService.ɵfac = function UniverseQuartileChartService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UniverseQuartileChartService)(); };
UniverseQuartileChartService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UniverseQuartileChartService, factory: UniverseQuartileChartService.ɵfac, providedIn: 'root' });
